import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Row from '../../Row';
import Col from '../../Col';
import Button from '../../Button';
import FontAwesomeIcon from '../../Icon';
import Form from '../../Form';
import Input from '../../Input';

import '../../SignatureCanvas/SignatureCanvas.scss';

import SignatureCanvas from '../../SignatureCanvas';
import { selectPropertyWalkThroughFormData } from '../../../store/selectors/propertyWalkThroughForm';
import { selectEasyWalkThroughFormData } from '../../../store/selectors/easyWalkThroughForm';
import { selectAuthenticatedUser } from '../../../store/selectors/auth';
import { setEasyWalkThroughFormData } from '../../../store/actions/easyWalkThroughForm';
import { setPropertyWalkThroughFormData } from '../../../store/actions/propertyWalkThroughForm';
import Loader from '../../Loader';
import ReviewTable1 from '../../ReviewTable/ReviewTable1';
import CreateDeveloperServiceRequest from './CreateDeveloperServiceRequest';
import { selectFormLoader } from '../../../store/selectors/FormLoader';
import Textarea from '../../Textarea';
import './OfflineWalkthroughData.scss';
import Avatar from '../../Avatar';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Lightbox from 'yet-another-react-lightbox';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import 'yet-another-react-lightbox/styles.css';

class CompleteWalkthrough extends Component {
  state = {
    showAddForm: false,
    firstName: '',
    lastName: '',
    role: '',
    email: '',
    atFirstOnly: true,
    serviceRequest: null,
    returnFromEditServiceRequest: false,
    walkThroughSignatureList: [],
    copied: true,
    selectedImages: [],
    showImages: false,
  };

  componentDidMount() {
    const { easyWalkThroughFormData, propertyWalkThroughFormData } = this.props;
    const {
      homeOwnerFirstName,
      homeOwnerLastName,
      propertyManagerFirstName,
      propertyManagerLastName,
    } = easyWalkThroughFormData;

    let mandatorySigns = [];
    if (propertyWalkThroughFormData.status === 'In Progress Home Only') {
      mandatorySigns = [
        {
          email: null,
          firstName: homeOwnerFirstName,
          lastName: homeOwnerLastName,
          role: 'Home Owner',
          signType: '',
          signature: '',
        },
      ];
    } else {
      if (
        propertyWalkThroughFormData.walkthroughType ===
          'Home Owner Walk-through' ||
        (propertyWalkThroughFormData.walkthroughType === 'Simplified' &&
          propertyWalkThroughFormData.permissions === 'Homeowner or Occupant' &&
          propertyWalkThroughFormData.isHomeOwner === true)
      ) {
        mandatorySigns = [
          {
            email: null,
            firstName: propertyManagerFirstName,
            lastName: propertyManagerLastName,
            role: 'Property Developer',
            signType: '',
            signature: '',
          },
          {
            email: null,
            firstName: homeOwnerFirstName,
            lastName: homeOwnerLastName,
            role: 'Home Owner',
            signType: '',
            signature: '',
          },
        ];
      } else {
        mandatorySigns = [
          {
            email: null,
            firstName: propertyManagerFirstName,
            lastName: propertyManagerLastName,
            role: 'Property Developer',
            signType: '',
            signature: '',
          },
        ];
      }
    }
    this.setState({ walkThroughSignatureList: mandatorySigns });
  }

  addOne() {
    const { easyWalkThroughFormData } = this.props;
    let signatures =
      easyWalkThroughFormData.walkThroughSignatureList &&
      easyWalkThroughFormData.walkThroughSignatureList.length > 0
        ? easyWalkThroughFormData.walkThroughSignatureList
        : [];
    let addSignee = [
      {
        button: 'Add Signee',
      },
    ];
  }

  handleSignature(image, signType, index, data, type) {
    const { firstName, lastName, role, email, walkThroughSignatureList } =
      this.state;
    let signatures =
      walkThroughSignatureList && walkThroughSignatureList.length > 0
        ? walkThroughSignatureList
        : [];
    let obj = {};
    if (image !== null) {
      if (type && type === 'AddNewSignee') {
        obj = {
          email,
          firstName,
          lastName,
          role,
          signType,
          signature: image,
        };
        this.setState({
          firstName: '',
          lastName: '',
          role: '',
          email: '',
          showAddForm: false,
        });
      } else {
        obj = data;

        obj = {
          ...obj,
          signature: image,
          signType: signType,
        };
      }
      let signs = [];
      if (signatures.length > 0) {
        let objExists = signatures[index] ? true : false;
        if (objExists === true) {
          signs = signatures.map((data, i) => {
            if (i === index) {
              return obj;
            } else {
              return data;
            }
          });
        } else {
          signs = [...signatures, ...[obj]];
        }
      } else {
        signs = [obj];
      }

      this.setState({ walkThroughSignatureList: signs });
    } else {
      toast.error('🚫 Please enter a valid signature.', {
        autoClose: 10000,
        position: 'top-center',
      });
    }
  }

  disableButton() {
    const { walkThroughSignatureList } = this.state;
    let signatures =
      walkThroughSignatureList && walkThroughSignatureList.length > 0
        ? walkThroughSignatureList
        : [];
    if (signatures.length > 0) {
      let disable = false;
      signatures.map((sign) => {
        if (sign.signature === null || sign.signature === '') {
          disable = true;
        }
      });

      return disable;
    } else {
      return true;
    }
  }

  signatures() {
    const { walkThroughSignatureList } = this.state;
    let signatures =
      walkThroughSignatureList && walkThroughSignatureList.length > 0
        ? walkThroughSignatureList
        : [];
    let mandatorySigns = [];

    mandatorySigns = [...signatures, ...[{ button: 'Add Signee' }]];
    return mandatorySigns;
  }

  handleSubmit() {
    const { handleCompleteWalkThrough } = this.props;
    const { walkThroughSignatureList } = this.state;

    handleCompleteWalkThrough(walkThroughSignatureList);
  }

  removeSignature(data, index) {
    const { walkThroughSignatureList } = this.state;
    let signs = [];
    for (let i = 0; i < walkThroughSignatureList.length; i++) {
      if (i === index) {
      } else {
        signs = [...signs, walkThroughSignatureList[i]];
      }
    }

    this.setState({ walkThroughSignatureList: signs });
  }

  async showImages(data) {
    let selectedImage;
    // let convertedImages = [];
    if (data && data.attachment) {
      selectedImage = JSON.parse(data.attachment);
      this.setState({
        selectedImages: selectedImage,
        showImages: true,
        selectedIndex: 0,
      });
    }
  }
  displayImages() {
    const { showImages, selectedImages, selectedIndex } = this.state;
    let type = selectedImages.length === 1 ? 'single' : 'multi';
    let url = selectedImages.length === 1 ? selectedImages[0] : '';
    if (showImages === true) {
      if (type === 'single') {
        return (
          <Lightbox
            open={showImages}
            close={() => this.setState({ showImages: false })}
            slides={[{ src: url }]}
            plugins={[Zoom]}
          />
        );
      } else {
        const slides = selectedImages.map((image) => ({ src: image }));

        return (
          <Lightbox
            open={showImages}
            close={() => this.setState({ showImages: false })}
            index={selectedIndex}
            slides={slides}
            plugins={[Zoom]}
            on={{
              view: ({ index }) => this.setState({ selectedIndex: index }),
            }}
          />
        );
      }
    }
  }
  checkAttachment(data) {
    if (data && data.attachment) {
      let attachment = data.attachment.split('/');
      return attachment.length > 0 ? true : false;
    } else {
      return false;
    }
  }

  render() {
    const {
      onClose,
      onExit,
      headline,
      strapline,
      easyWalkThroughFormData,
      user,
      loader,
      onSetEasyWalkThroughFormData,
      propertyWalkThroughFormData,
      types,
      areas,
      subAreasByLocation,
      locations,
    } = this.props;
    const { showAddForm, firstName, lastName, email, role, showImages } =
      this.state;

    let serviceRequests =
      easyWalkThroughFormData.walkThroughServiceRequests &&
      easyWalkThroughFormData.walkThroughServiceRequests.length > 0
        ? easyWalkThroughFormData.walkThroughServiceRequests
        : [];
    let signatures = this.signatures();

    return (
      <Form
        headline={headline ? headline : ''}
        strapline={strapline ? strapline : ''}
        onClose={onClose}
        onExit={onClose}
        component={
          easyWalkThroughFormData.walkThroughServiceRequestListLoading &&
          easyWalkThroughFormData.walkThroughServiceRequestListLoading ===
            true ? (
            <div style={{ justifyContent: 'center', alignItems: 'center' }}>
              {' '}
              <Loader center={true} />{' '}
            </div>
          ) : (
            <>
              {loader ? <Loader center={true} /> : null}
              {easyWalkThroughFormData &&
              easyWalkThroughFormData.serviceRequestId ? (
                <CreateDeveloperServiceRequest
                  subAreasByLocation={subAreasByLocation}
                  locations={locations}
                  easyWalkThroughFormData={easyWalkThroughFormData}
                  onSetEasyWalkThroughFormData={onSetEasyWalkThroughFormData}
                  areas={areas}
                  types={types}
                  handleDelete={this.props.handleDelete}
                  onSelectImage={this.props.onSelectImage}
                  updateServiceRequest={this.props.updateServiceRequest}
                  onCreateServiceRequest={this.onCreateServiceRequest}
                />
              ) : null}
              <div className="offlineWalkthroughData__listView">
                {serviceRequests && serviceRequests.length > 0 ? (
                  <ReviewTable1
                    columns={[
                      {
                        xsHide: true,
                        label: 'Location',
                        cell: (data) =>
                          data.area && data.area.name
                            ? data.area.name
                            : data.areaName
                              ? data.areaName
                              : '',
                      },
                      {
                        xsHide: true,
                        label: 'Item',
                        cell: (data) => {
                          return data && data.itemName
                            ? data.itemName
                            : data &&
                                data.asset &&
                                data.asset.item &&
                                data.asset.item.name
                              ? data.asset.item.name
                              : '';
                        },
                      },
                      {
                        xsHide: true,
                        label: 'Issue Type',
                        cell: (data) =>
                          data.serviceType
                            ? data.serviceType
                            : data.issueType && data.issueType.name
                              ? data.issueType.name
                              : data.issueType
                                ? data.issueType
                                : '',
                      },
                      {
                        label: 'Description',
                        cell: (data) => data.description,
                      },
                      {
                        label: <FontAwesomeIcon glyph="paperclip" weight="light" />,
                        cell: (data) => (
                          <>
                            {this.checkAttachment(data) ? (
                              <div onClick={() => this.showImages(data)}>
                                <div className="reviewMobileAvatar">
                                  <Avatar
                                    badge={
                                      JSON.parse(data.attachment).length > 1
                                        ? 'count'
                                        : ''
                                    }
                                    url={JSON.parse(data.attachment)[0]}
                                  />
                                </div>
                              </div>
                            ) : null}
                          </>
                        ),
                      },
                      propertyWalkThroughFormData.status === 'Review'
                        ? ''
                        : {
                            label: '',
                            cell: (data) => (
                              <>
                                <div
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                  }}
                                >
                                  <div
                                    style={{
                                      display: 'flex',
                                      cursor: 'pointer',
                                    }}
                                    onClick={() =>
                                      this.props.editServiceRequest(data)
                                    }
                                  >
                                    <FontAwesomeIcon glyph="pencil" weight="light" />
                                  </div>

                                  <div
                                    style={{
                                      marginLeft: 20,
                                      cursor: 'pointer',
                                    }}
                                    onClick={() =>
                                      window.confirm(
                                        `Are you sure you want to delete ${data.ticketId}?`
                                      ) && this.props.deleteServiceRequest(data)
                                    }
                                  >
                                    <FontAwesomeIcon glyph="trash" weight="light" />
                                  </div>
                                </div>
                              </>
                            ),
                          },
                    ]}
                    data={serviceRequests}
                  />
                ) : null}
                {showImages === true ? <>{this.displayImages()}</> : null}
              </div>
              <div style={{ marginTop: 20 }}>
                <Textarea
                  value={easyWalkThroughFormData.notes}
                  onChange={(e) =>
                    onSetEasyWalkThroughFormData({ notes: e.target.value })
                  }
                  label="Notes"
                  placeholder="Notes"
                  block
                />
              </div>
              <div style={{ height: 30 }} />

              <Row>
                {signatures && signatures.length > 0
                  ? signatures.map((data, index) =>
                      data.button === 'Add Signee' ? (
                        <>
                          <Col xs="12" md="6">
                            {showAddForm ? (
                              <div>
                                <div
                                  style={{ paddingLeft: 40, paddingRight: 40 }}
                                >
                                  <Row>
                                    <Col xs="12" md="6">
                                      <Input
                                        value={firstName}
                                        onChange={(e) =>
                                          this.setState({
                                            firstName: e.target.value,
                                          })
                                        }
                                        placeholder="First Name"
                                        block
                                      />
                                    </Col>
                                    <Col xs="12" md="6">
                                      <Input
                                        value={lastName}
                                        onChange={(e) =>
                                          this.setState({
                                            lastName: e.target.value,
                                          })
                                        }
                                        placeholder="Last Name"
                                        block
                                      />
                                    </Col>
                                  </Row>

                                  <Row>
                                    <Col xs="12" md="6">
                                      <Input
                                        value={role}
                                        onChange={(e) =>
                                          this.setState({
                                            role: e.target.value,
                                          })
                                        }
                                        placeholder="Role"
                                        block
                                      />
                                    </Col>
                                    <Col xs="12" md="6">
                                      <Input
                                        value={email}
                                        onChange={(e) =>
                                          this.setState({
                                            email: e.target.value,
                                          })
                                        }
                                        placeholder="Email Address"
                                        block
                                      />
                                    </Col>
                                  </Row>
                                </div>

                                <SignatureCanvas
                                  onInsert={(url, signType) => {
                                    this.setState({ showOverlay: false });
                                    this.handleSignature(
                                      url,
                                      signType,
                                      index,
                                      null,
                                      'AddNewSignee'
                                    );
                                  }}
                                  firstName={firstName ? firstName : ''}
                                  lastName={lastName ? lastName : ''}
                                  signed=""
                                  signType={1}
                                  typeOfSign={
                                    propertyWalkThroughFormData.walkthroughType
                                  }
                                  permissions={
                                    propertyWalkThroughFormData.permissions
                                      ? propertyWalkThroughFormData.permissions
                                      : ''
                                  }
                                />
                              </div>
                            ) : (
                              <div
                                style={{
                                  color: '#00848E',
                                  display: 'flex',
                                  height: '35vh',
                                  backgroundColor: 'rgba(214, 207, 207, 0.1)',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  marginTop: 40,
                                }}
                                onClick={() =>
                                  this.setState({ showAddForm: true })
                                }
                              >
                                <div style={{ paddingRight: 3 }}>
                                  <FontAwesomeIcon glyph="plus-circle" weight="regular" />
                                </div>
                                <div style={{ fontWeight: 600 }}>
                                  {data.button?.toUpperCase()}
                                </div>
                              </div>
                            )}
                          </Col>
                        </>
                      ) : (
                        <>
                          <Col xs="12" md="6">
                            <Row mdCenter>
                              <Col md="8">
                                <div
                                  style={{
                                    textAlign: 'center',
                                    fontWeight: 700,
                                  }}
                                >
                                  {data.firstName} {data.lastName} {data.role}{' '}
                                  Signature
                                </div>
                              </Col>
                            </Row>

                            <SignatureCanvas
                              onInsert={(url, signType) => {
                                this.handleSignature(
                                  url,
                                  signType,
                                  index,
                                  data
                                );
                              }}
                              signed={
                                data.signature !== '' || data.signature !== null
                                  ? data.signature
                                  : ''
                              }
                              signType={data.signType}
                              remove={() => this.removeSignature(data, index)}
                              firstName={data.firstName ? data.firstName : ''}
                              lastName={data.lastName ? data.lastName : ''}
                              typeOfSign={
                                propertyWalkThroughFormData.walkthroughType
                              }
                              permissions={
                                propertyWalkThroughFormData.permissions
                                  ? propertyWalkThroughFormData.permissions
                                  : ''
                              }
                            />
                          </Col>
                        </>
                      )
                    )
                  : null}
              </Row>
              <div style={{ height: 30 }} />

              <div style={{ textAlign: 'center' }}>
                <Button
                  color="complete_purple"
                  label="Submit"
                  onClick={() => this.handleSubmit()}
                  size="bar"
                  disabled={this.disableButton()}
                />
              </div>
            </>
          )
        }
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let propertyWalkThroughFormData = selectPropertyWalkThroughFormData(state);
  let easyWalkThroughFormData = selectEasyWalkThroughFormData(state);
  return {
    easyWalkThroughFormData,
    propertyWalkThroughFormData,
    user: selectAuthenticatedUser(state),
    types: state.formOptions.types,
    areas: state.areas,
    loader: selectFormLoader(state),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onSetEasyWalkThroughFormData: setEasyWalkThroughFormData,
      onSetPropertyWalkThroughFormData: setPropertyWalkThroughFormData,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CompleteWalkthrough);
